import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = "/images/logo.png";

export const Impressum = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="impressum-page">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl shadow-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={LOGO_URL} alt="Geile Kiste Logo" className="h-10 w-auto" />
          </Link>
          <Link 
            to="/" 
            className="flex items-center gap-2 text-gray-600 hover:text-[#3ECDC3] transition-colors"
            data-testid="back-home-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="pt-32 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-8"
            
          >
            Impressum
          </h1>

          <div className="prose prose-gray max-w-none space-y-8">
            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">Angaben gemäß § 5 TMG</h2>
              <p className="text-gray-600">
                geile Kiste<br />
                Eugen Limon<br />
                Fotobox Verleih<br />
                Hölzlestraße 27<br />
                78315 Radolfzell am Bodensee
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">Kontakt</h2>
              <p className="text-gray-600">
                Telefon: +49 (0) 152 239 588 67<br />
                E-Mail: impressum@geile-kiste.com
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">Umsatzsteuer</h2>
              <p className="text-gray-600">
                Als Kleinunternehmer im Sinne von § 19 Abs. 1 UStG wird keine Umsatzsteuer berechnet.<br />
                Daher erfolgt keine Angabe einer Umsatzsteuer-Identifikationsnummer.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <p className="text-gray-600">
                Eugen Limon<br />
                Hölzlestraße 27<br />
                78315 Radolfzell am Bodensee
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">Haftungsausschluss</h2>
              
              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Haftung für Inhalte</h3>
              <p className="text-gray-600 leading-relaxed">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>

              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Haftung für Links</h3>
              <p className="text-gray-600 leading-relaxed">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              </p>

              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Urheberrecht</h3>
              <p className="text-gray-600 leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#3ECDC3] mb-4">Streitschlichtung</h2>
              <p className="text-gray-600 leading-relaxed">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#3ECDC3] hover:underline">https://ec.europa.eu/consumers/odr/</a>
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                <strong>Hinweis nach §§ 36, 37 VSBG:</strong> Wir sind nicht bereit und nicht verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 py-8 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} geile Kiste. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <Link to="/impressum" className="text-[#3ECDC3] font-medium text-sm">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-gray-500 hover:text-[#3ECDC3] transition-colors text-sm">
              Datenschutz
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
